import { FC, createContext, useContext, useState } from 'react';
import { Moment, MomentInput } from 'moment';

export type InsightsQueryState = {
  startDate: MomentInput;
  endDate: MomentInput;
  setStartDate: (startDate: Moment | null) => void;
  setEndDate: (startDate: Moment | null) => void;
};

export const defaultState = {
  startDate: null,
  endDate: null,
  setStartDate: () => null,
  setEndDate: () => null,
};

export const InsightsQueryContext = createContext<InsightsQueryState>(defaultState);

export const useInsightsQueryContext = () => useContext(InsightsQueryContext);

export const InsightsQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [startDate, setStartDate] = useState<Moment | null>(null);
  const [endDate, setEndDate] = useState<Moment | null>(null);

  const context: InsightsQueryState = {
    startDate,
    endDate,
    setStartDate,
    setEndDate,
  };

  return <InsightsQueryContext.Provider value={context}>{children}</InsightsQueryContext.Provider>;
};
